import { FC } from "react";
import SearchBox from "../../../../components/components-library/searchbox";
import ONOCalendarV2 from "../../../../components/commons/ono-calendar-v2/ono_calendar_v2";
import FilterButton from "../../../../components/ui/filter_button/FilterButton";
import RefreshButton from "../../../../components/ui/refresh_button/RefreshButton";
import ToggleCard from "../../../../components/toggle-cards/toggle_card";
import payments from "../../../../assets/images/payments_circled.svg";
import { getCurrencyNumberWithSymbol } from "../../../../helpers/get-currency-number";
import CollectionsTable from "./CollectionsTable";
import useCollections from "../bloc/useCollections";
import PayoutViewPage from "../../payout_view/ui/PayoutViewPage";
import CollectionFilterView from "../collection_filter/ui/CollectionFilterView";
import excel from "../../../../assets/images/excel.svg";

const CollectionsPage: FC<{}> = () => {
  const {
    searchText,
    setSearchText,
    calendarDate,
    collections,
    onChangeDate,
    onRefresh,
    onClickCollection,
    collectionSummary,
    isCollapsed,
    setIsCollapsed,
    showPayoutView,
    setShowPayoutView,
    showFilters,
    setShowFilters,
    filters,
    isFilterApplied,
    handleCollectionsExport,
  } = useCollections();

  return (
    <div className="p-20">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1">
          <SearchBox
            className="mr-2"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            placeholder={"Search by UTR / Customer"}
          />
        </div>
        <div className="flex flex-1 justify-center">
          <ONOCalendarV2
            mode={calendarDate.mode}
            onChangeDate={(fromDate, toDate, mode) => {
              onChangeDate(fromDate, toDate, mode);
            }}
            fromDate={calendarDate.fromDate}
            toDate={calendarDate.toDate}
          />
        </div>
        <div className="flex flex-1 justify-end gap-2">
          <button
            className="flex items-center text-sm gap-2 bg-primary text-white px-4 py-2 rounded-full justify-end"
            onClick={() => {
              handleCollectionsExport();
            }}
          >
            <img src={excel} alt="" className="h-6 w-6" />
            Export to Excel
          </button>
          <RefreshButton onClick={onRefresh} />
          <FilterButton
            onClick={() => {
              setShowFilters(true);
            }}
            isFilterApplied={isFilterApplied()}
          />
        </div>
      </div>
      <div className="mt-5">
        <ToggleCard
          list={[
            {
              label: "Total Collections",
              value: getCurrencyNumberWithSymbol(collectionSummary.total, true),
              icon: payments,
            },
            {
              label: "Number Of Colletions",
              value: collectionSummary.noOfCollections.toString(),
              icon: payments,
            },
          ]}
          onClick={(val) => {
            setIsCollapsed(!isCollapsed);
          }}
        />
      </div>
      <div className="mt-5">
        <CollectionsTable
          searchText={searchText}
          collections={collections}
          onClick={onClickCollection}
          isCardCollpased={isCollapsed}
          filters={filters}
        />
      </div>
      {showPayoutView && (
        <PayoutViewPage
          open={showPayoutView}
          onClose={() => {
            setShowPayoutView(false);
          }}
        />
      )}
      {showFilters && (
        <CollectionFilterView
          open={showFilters}
          onClose={() => {
            setShowFilters(false);
          }}
        />
      )}
    </div>
  );
};

export default CollectionsPage;
